<template>
  <div id="master">
    <div class="master-header">
      <h1 class="scarlet">SELECCIONA</h1>
      <p class="font-300">El congresista que quieres explorar</p>
    </div>
    <div class="master-characters">
      <div class="master-character column" v-for="(character, index) in characters" :key="index" @click="showDetails(character)">
        <img :src="character.sketch" :alt="character.fullname" />
        <pre class="font-300">{{ character.shortname | format }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['characters'],
  methods: {
    showDetails (character) {
      this.$emit('detail', character)
    }
  },
  filters: {
    format (str) {
      if (!str) return
      return str.split(' ').join('\n').replace(/-/g, ' ')
    }
  }
}
</script>

<style scoped>
#master {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto 0;
}
.master-header {
  text-align: center;
}
.master-header h1,
.master-header p {
  margin: 0;
}
.master-characters {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  margin-top: 20px;
  padding: 0 10px;
}
.master-character {
  cursor: pointer;
}
.master-character img {
  border-radius: 50%;
  display: block;
  margin: 0 auto;
  max-height: 70px;
  max-width: 70px;
}
.master-character pre {
  margin: 0;
  text-align: center;
}
@media only screen and (min-width: 768px) {
  .master-characters {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  }
  .master-character img {
    max-width: 150px;
    max-height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Master.vue